import axios from 'axios';

export const fetchQuestionnaireLogs = async (projectKey, apiKey, questionnaireId, requestId, userId, start = 0, size = 10) => {
    const url = `${process.env.VUE_APP_RECOMMENDER_API}/v1/questionnaires/logs`;
    const headers = {
        'accept': 'application/json',
        'project-key': projectKey,
        'api-key': apiKey,
    };
    const params = {
        questionnaire_id: questionnaireId,
        request_id: requestId,
        user_id: userId,
        start,
        size
    };

    try {
        const response = await axios.get(url, { headers, params });
        // console.log('Logs:', response.data);
        return response.data;
    } catch (error) {
        console.error('Error fetching logs:', error.response?.data || error.message);
        throw error;
    }
}

// Function to fetch conversation data
export const fetchConversation = async (projectKey, apiKey, conversationId) => {
    const url = `${process.env.VUE_APP_RECOMMENDER_API}/v1/gpt/conversations/${conversationId}`;
    const headers = {
        'accept': 'application/json',
        'project-key': projectKey,
        'api-key': apiKey,
    };
    try {
        const response = await axios.get(url, { headers });
        // console.log('Conversation:', response.data);
        return response.data;
    } catch (error) {
        console.error('Error fetching conversation:', error);
        throw error;
    }
};

export const fetchChildItems = async (credentials, recommendedProducts) => {
    try {
        const headers = {
            "accept": "application/json",
            "project-key": credentials.projectKey,
            "api-key": credentials.apiKey,
        };

        const childItemsMap = {};

        for (const category in recommendedProducts) {
            for (const item of recommendedProducts[category]) {
                if (item.child_items && item.child_items.length > 0) {
                    const cleanedIds = item.child_items.map((id) => id.trim());
                    const response = await axios.post(
                        `${process.env.VUE_APP_RECOMMENDER_API}/v1/items`,
                        { ids: cleanedIds },
                        { headers }
                    );
                    childItemsMap[item.item_id] =
                        response.data?.detail?.response || [];
                } else {
                    childItemsMap[item.item_id] = [];
                }
            }
        }
        return childItemsMap;
    } catch (error) {
        console.error("Error fetching child items:", error);
        throw error;
    }
}